<template>
  <b-modal
    id="add-operation-construction-modal"
    :ok-title="$t('Add')"
    :title="$t('Add') + ' ' + typeConstructionText"
    @close="hideModal"
    centered
    ok-only
    ok-variant="primary"
    no-close-on-backdrop
    @ok="handleOk">
    <form ref="operationForm" novalidate>
      <div class="my-2 row">
        <div class="col-md-6 mt-2">
          <b-form-group
            :label="$t('operationConstruction.Name')"
            class="medium-label mb-4"
            label-for="name-input">
            <b-form-input
              id="name-input"
              v-model="name"
              required
              type="text">
            </b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-6 mt-2">
          <b-form-group
            :label="$t('operationConstruction.UniteConstruction')"
            class="medium-label mb-4"
            label-for="uniteConstruction-input">
            <b-form-select
              id="uniteConstruction-input"
              v-model="uniteConstruction"
              required
              @change="handleChangeUniteConstruction">
              <option v-for="option in filteredUnitesConstruction" :key="option.value" :value="option.value">
                {{ $t(option.text) }}
              </option>
            </b-form-select>
          </b-form-group>
        </div>

        <!-- Mode M2 -->
        <template v-if="uniteConstruction === 'M2'">
          <div class="col-md-6">
            <b-form-group
              :label="$t('operationConstruction.Surface')"
              :label-for="'Surface-input'"
              class="medium-label mb-2">
              <b-input-group
                :id="'Surface-input'">
                <b-form-input
                  v-model="surface"
                  v-disable-scroll
                  min="0"
                  required
                  @change="changeValueTTC()"
                  @input="changeValueTTC()"
                  step="any"
                  type="number">
                </b-form-input>
                <b-input-group-append>m²</b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              :label="$t('operationConstruction.PrixParM2')"
              :label-for="'PrixParM2-input'"
              class="medium-label mb-2">
              <b-input-group
                :id="'PrixParM2-input'">
                <b-form-input
                  v-model="prixParM2Model"
                  v-disable-scroll
                  min="0"
                  required
                  step="any"
                  @change="changeValueTTC()"
                  @input="changeValueTTC()"
                  type="number">
                </b-form-input>
                <b-input-group-append>{{ isHT ? $t('euros.prixHT') : $t('euros.prixTTC') }}/m²</b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              :label="isHT ? $t('operationConstruction.prixHT') : $t('operationConstruction.prixTTC')"
              :label-for="'prixTTC-input'"
              class="medium-label mb-2">
              <b-input-group
                :id="'prixTTC-input'">
                <b-form-input
                  v-model="prixAffiche"
                  disabled
                  type="number">
                </b-form-input>
                <b-input-group-append>€</b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </template>

        <!-- Mode UNITAIRE -->
        <template v-else-if="uniteConstruction === 'UNITAIRE'">
          <div class="col-md-6">
            <b-form-group
              :label="isHT ? $t('operationConstruction.Prix.HT') : $t('operationConstruction.PrixTTC')"
              :label-for="'prixTTC-input-'"
              class="medium-label mb-2">
              <b-input-group
                :id="'prixTTC-input-'">
                <b-form-input
                  v-model="prixParM2Model"
                  v-disable-scroll
                  min="0"
                  required
                  step="any"
                  type="number">
                </b-form-input>
                <b-input-group-append>{{ isHT ? $t('euros.prixHT') : $t('euros.prixTTC') }}</b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </template>

        <!-- Nouveaux modes de calcul par pourcentage -->
        <template v-else-if="isPercentageMode">
          <div class="col-md-6">
            <b-form-group
              :label="$t('operationConstruction.Pourcentage')"
              :label-for="'pourcentage-input'"
              class="medium-label mb-2">
              <b-input-group
                :id="'pourcentage-input'">
                <b-form-input
                  v-model="pourcentage"
                  v-disable-scroll
                  min="0"
                  max="100"
                  required
                  step="0.01"
                  @change="calculatePercentageValue()"
                  @input="calculatePercentageValue()"
                  type="number">
                </b-form-input>
                <b-input-group-append>%</b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              :label="$t('operationConstruction.prixTTC')"
              :label-for="'prixTTC-percentage-input'"
              class="medium-label mb-2">
              <b-input-group
                :id="'prixTTC-percentage-input'">
                <b-form-input
                  v-model="prixTTCInEuros"
                  disabled
                  type="number">
                </b-form-input>
                <b-input-group-append>€</b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>


        </template>

        <div class="col-md-6">
          <b-form-group
            :label="$t('operationConstruction.TauxTVA')"
            :label-for="'tauxTVA-input'"
            class="medium-label mb-2">
            <b-form-select
              id="'tauxTVA-input'"
              v-model="tauxTVA"
              required>
              <option v-for="option in filteredTauxTVAList" :key="option.value" :value="option.value">
                {{ $t(option.text) }}
              </option>
            </b-form-select>
          </b-form-group>
        </div>

        <div class="col-md-6">
          <AutocompleteField
            v-model="contactName"
            :input-class="'medium-label mb-2'"
            :input-id="'contact-input'"
            :input-label="$t('operationConstruction.Contact.Name')"
            :items="contactNames"
            :required=false
            @elementValueChanged="getSelectedValueContact">
          </AutocompleteField>
        </div>
        <div class="col-md-6">
          <b-form-group
            :label="$t('operationConstruction.datedebut')"
            :label-for="'date-input'"
            :state="stateDate"
            class="medium-label mb-2">
            <datepicker-input
              :id="'date-input'"
              v-model="date"
              :state="stateDate"
              required
              @change="stateDate=null"
              @input="stateDate=null">
            </datepicker-input>
          </b-form-group>
        </div>

        <div class="col-md-6">
          <b-form-group
            :label="$t('operationConstruction.datefin')"
            :label-for="'date-input-endDate'"
            :state="stateEndDate"
            class="medium-label mb-2">
            <datepicker-input
              :id="'date-input-endDate'"
              v-model="endDate"
              :state="stateEndDate"
              required
              @change="stateEndDate=null"
              @input="stateEndDate=null">
            </datepicker-input>
          </b-form-group>
        </div>

        <div
          v-if="operation"
          class="col-md-12 ">
          <b-form-group
            :label="$t('operationConstructions.lots.tolink')"
            :label-for="'lots-input'"
            class="medium-label mb-2">

            <div :id="'lots-input'" class="custom-container">
              <b-form-checkbox
                v-for="(operationLot, index) in operationLots"
                :key="operationLot.id"
                :ref="'checkbox' + operationLot.id"
                :checked="selectedLots&&selectedLots.includes(operationLot.id)"
                @change="handleCheckboxChange(operationLot.id)">
                  <span v-if="operationLot.lotCoPro">{{
                      $t('operation.bilan.Lot') + ' ' + operationLot.lotCoPro
                    }}</span>
                <span v-else>{{ $t('operation.bilan.Lot') + ' ' + operationLot.lotNumber }}</span>
              </b-form-checkbox>
            </div>
          </b-form-group>
        </div>

      </div>
    </form>
  </b-modal>
</template>

<script>
import AutocompleteField from "../../../components/b122/editFields/AutocompleteField";
import DatepickerInput from "../../../components/b122/editFields/DatepickerInput.vue";
import api from "../../../services/api";

export default {
  name: "AddOperationConstructionModal",

  components: {
    AutocompleteField,
    DatepickerInput
  },

  props: {
    operation: {
      type: Object,
      default: null
    },
    operationLot: {
      type: Object,
      default: null
    },
    typeConstruction: {
      type: Object,
      default: null
    },
    unitesConstruction: {
      type: Array,
      default() {
        return []
      }
    },
    tauxTVAList: {
      type: Array,
      default: () => [],
    },
    operationLots: {
      type: Array,
      default: () => [],
    },
    allInitialDateOperationAndLot: {
      type: Object,
      default: null
    },
    contactNames: {
      type: Array,
      default() {
        return []
      }
    },
    isHT:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: null,
      uniteConstruction: null,
      contactName: null,
      surface: null,
      prixAffiche: null,
      prixParM2: null,
      prixParM2HT: null,
      prixTTC: null,
      pourcentage: null,
      tauxTVA: null,
      date: null,
      stateDate: null,
      stateEndDate: null,
      endDate: null,
      selectedLots: this.operationLots.map(lot => lot.id),
    }
  },


  computed: {
    prixParM2Model: {
      get() {
        return this.isHT ? this.prixParM2HT : this.prixParM2
      },
      set(val) {
        if (this.isHT) {
          this.prixParM2HT = val
        } else {
          this.prixParM2 = val
        }
      }
    },
    typeConstructionText() {
      return this.typeConstruction ? this.$i18n.t(this.typeConstruction.text) : ''
    },
    filteredTauxTVAList() {
      if (this.tauxTVAList && this.tauxTVAList.length > 0) {
        return this.tauxTVAList;
      }
      return []
    },
    isPercentageMode() {
      return this.uniteConstruction && [
        'POURCENTAGE_CA_TTC'
      ].includes(this.uniteConstruction);
    },

    prixTTCInEuros() {
      if (!this.prixTTC || isNaN(this.prixTTC)) return 0;

      if (this.isPercentageMode) {
        return Number(this.prixTTC).toFixed(2);
      }

      return Number(this.prixTTC).toFixed(2);
    },

    filteredUnitesConstruction() {
      if (this.operationLot) {

        return this.unitesConstruction.filter(option => ![
          'POURCENTAGE_CA_TTC',
          'POURCENTAGE_COUT_TRAVAUX',
          'POURCENTAGE_PRIX_REVIENT'
        ].includes(option.value));
      }

      return this.unitesConstruction.filter(option => ![
        'POURCENTAGE_COUT_TRAVAUX',
        'POURCENTAGE_PRIX_REVIENT'
      ].includes(option.value));
    }
  },
  emits: ['didAddOperationConstruction'],

  async mounted() {
    this.selectedLots = this.operationLots.map(lot => lot.id);
    if (this.allInitialDateOperationAndLot["operation"]) {
      this.date = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionStartDate);
      this.endDate = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionEndDate);
      if (this.operationLot != null) {
        if (this.getInitialDate(this.allInitialDateOperationAndLot, this.operationLot.id, "operationLots", "estimatedStartDate")) {
          this.date = this.getInitialDate(this.allInitialDateOperationAndLot, this.operationLot.id, "operationLots", "estimatedStartDate")
          this.endDate = this.getInitialDate(this.allInitialDateOperationAndLot, this.operationLot.id, "operationLots", "estimatedEndDate")
        }
      }
    }
  },

  methods: {
    getSelectedValueContact(data) {
      this.contactName = data
    },

    async changeValueTTC() {
      this.prixTTC = this.surface ? (this.surface * this.prixParM2) : this.prixParM2
      this.prixAffiche = this.surface
        ? (this.surface * (this.isHT ? this.prixParM2HT : this.prixParM2))
        : (this.isHT ? this.prixParM2HT : this.prixParM2)

    },

    async calculatePercentageValue() {
      if (!this.pourcentage || !this.operation) return;

      let baseValue = 0;

      try {
        switch(this.uniteConstruction) {
          case 'POURCENTAGE_CA_TTC':

            const responseCATTC = await api.get(`/operationConstruction/getCATTC?operationId=${this.operation.id}`);
            baseValue = (responseCATTC.data.caTTC || 0) / 100;
            break;
          case 'POURCENTAGE_COUT_TRAVAUX':

            const responseCoutTravaux = await api.get(`/operationConstruction/getCoutTravaux?operationId=${this.operation.id}`);
            baseValue = (responseCoutTravaux.data.coutTravaux || 0) / 100;
            break;
          case 'POURCENTAGE_PRIX_REVIENT':

            const responsePrixRevient = await api.get(`/operationConstruction/getPrixRevient?operationId=${this.operation.id}`);
            baseValue = (responsePrixRevient.data.prixRevient || 0) / 100;
            break;
        }

        this.prixTTC = (baseValue * this.pourcentage / 100).toFixed(2);
      } catch (error) {
        console.error('Erreur lors du calcul du pourcentage:', error);
        this.prixTTC = 0;
      }
    },

    getPercentageModeDescription() {
      switch(this.uniteConstruction) {
        case 'POURCENTAGE_CA_TTC':
          return 'Pourcentage du Chiffre d\'Affaires TTC';
        case 'POURCENTAGE_COUT_TRAVAUX':
          return 'Pourcentage du coût des travaux';
        case 'POURCENTAGE_PRIX_REVIENT':
          return 'Pourcentage du prix de revient';
        default:
          return '';
      }
    },

    getPercentageModeDetails() {
      switch(this.uniteConstruction) {
        case 'POURCENTAGE_CA_TTC':
          return 'Le montant sera calculé automatiquement en fonction du pourcentage du chiffre d\'affaires total des ventes TTC.';
        case 'POURCENTAGE_COUT_TRAVAUX':
          return 'Le montant sera calculé automatiquement en fonction du pourcentage du coût total des travaux.';
        case 'POURCENTAGE_PRIX_REVIENT':
          return 'Le montant sera calculé automatiquement en fonction du pourcentage du prix de revient total (charges foncières + travaux + honoraires + charges).';
        default:
          return '';
      }
    },

    getInitialDate(source, id, type, dateType) {
      let dateLong = source[type].find(x => x.id === id)[dateType];
      if (dateLong != null) {
        return this.formatDate(dateLong);
      }
      return null;
    },

    formatDate(dateLong) {
      return new Date(Number(dateLong)).toLocaleDateString().split("/").reverse().join("-");
    },

    handleCheckboxChange(lotId) {
      const index = this.selectedLots.indexOf(lotId);
      if (index === -1) {
        this.selectedLots.push(lotId);
      } else {
        if (this.selectedLots.length > 1) {
          this.selectedLots.splice(index, 1);
        } else {
          this.$refs["checkbox" + lotId][0].checked = true;
          this.$refs["checkbox" + lotId][0].computedLocalChecked = true;
          this.$refs["checkbox" + lotId][0].localChecked = true;
        }
      }
    },

    handleChangeUniteConstruction() {
      this.surface = null;
      this.prixParM2 = null;
      this.prixTTC = null;
      this.pourcentage = null;
    },

    handleOk($event) {
      const form = this.$refs.operationForm;
      if (!form.reportValidity() || !this.date || !this.endDate) {
        $event.preventDefault();
        if (!this.date) {
          this.stateDate = false;
        }
        if (!this.endDate) {
          this.stateEndDate = false;
        }
        return
      }
      this.handleSubmit();
    },

    handleSubmit() {
      if (this.name != null && this.name.trim() !== '' && this.date && this.endDate) {
        let operationConstruction = {
          operationLot: this.operationLot,
          operation: this.operation,
          typeConstruction: this.typeConstruction,
          uniteConstruction: this.unitesConstruction.find((unite) => unite.value === this.uniteConstruction),
          name: this.name,
          surface: this.surface,
          prixParM2: this.prixParM2,
          prixParM2HT: this.prixParM2HT,
          prixTTC: this.isHT ? null : this.prixAffiche,
          prixHT: this.isHT ? this.prixAffiche : null,
          pourcentage: this.pourcentage,
          contactName: this.contactName,
          tauxTVA: this.tauxTVA,
          date: this.date,
          endDate: this.endDate,
          id: null,
          selectedLots: this.selectedLots,
          devis: []
        }
        this.$emit('didAddOperationConstruction', operationConstruction)
        this.resetModal()
        this.hideModal()
      }
    },

    resetModal() {
      this.name = null;
      this.uniteConstruction = null;
      this.surface = null;
      this.prixParM2 = null;
      this.prixTTC = null;
      this.prixParM2HT = null;
      this.prixAffiche = null;
      this.pourcentage = null;
      this.tauxTVA = null;
      this.date = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionStartDate);
      this.endDate = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionEndDate);
      if (this.operationLot != null) {
        if (this.getInitialDate(this.allInitialDateOperationAndLot, this.operationLot.id, "operationLots", "estimatedStartDate")) {
          this.date = this.getInitialDate(this.allInitialDateOperationAndLot, this.operationLot.id, "operationLots", "estimatedStartDate")
          this.endDate = this.getInitialDate(this.allInitialDateOperationAndLot, this.operationLot.id, "operationLots", "estimatedEndDate")
        }
      }
      this.selectedLots = this.operationLots.map(lot => lot.id);
    },

    hideModal() {
      this.resetModal()
      this.$bvModal.hide('add-operation-construction-modal')
    }
  }
}
</script>

<style scoped>
.prixTTCContainer {
  padding: 8px 12px;
  background-color: #F4F4F4;
  color: #07153C;
  border: solid 1px #CCCCCC;
}

.prixTTC {
  color: var(--main-color);
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: 0 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.grey-text {
  color: #AAAAAA;
}

.custom-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.custom-container > * {
  margin-left: 1em;
}
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/AddOperationConstructionModal.vue